(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReportExportController', ReportExportController);

    ReportExportController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$translate', 'CompanyCustom', '$uibModal'];

    function ReportExportController($scope, Principal, LoginService, $state, translate, CompanyCustom, $uibModal) {
        var vm = this;

        vm.report1_spname = 'search_company';
        vm.report1_parameters = [{name: 'url', value: 'tamin20'}];
        vm.currentCompany = null;
        vm.doBeforeExport_customerList = doBeforeExport_customerList;
        vm.showEducation = showEducation

        findCurrentCompany();

        function findCurrentCompany() {

            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;

            });
        }

        function doBeforeExport_customerList() {

            var report_config = {
                spname: 'sp_company_customer_list',
                parameters: [{name: 'f_company_id', value: (vm.currentCompany.id), type: 'long'}]
            };

            return report_config;

        }
         function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                         return '<div id="60236964718"><script type="text/JavaScript" src="https://www.aparat.com/embed/nkek6b9?data[rnddiv]=60236964718&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

    }
})();
